import React, { Component } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';

//SPO2 img
import SPO2_grey from '../../Images/SPO2/spo2_grey.png';
import SPO2_green from '../../Images/SPO2/spo2_green.png';
import SPO2_orange from '../../Images/SPO2/spo2_orange.png';
import SPO2_red from '../../Images/SPO2/spo2_red.png';

class Sp02Display extends Component {

    //Function to display SpO2 alert logo with the good color
    getSpO2Img(){
        if(this.props.spo2Display.color === "#21BA45"){
            //return green
            return (<img src={SPO2_green} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="SPO2_logo"/>)
        }
        else if(this.props.spo2Display.color === "#F2711C"){
            //return orange
            return (<img src={SPO2_orange} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="SPO2_logo"/>)
        }
        else if(this.props.spo2Display.color === "#DB2828"){
            //return orange
            return (<img src={SPO2_red} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="SPO2_logo"/>)
        }
        else{
            //return grey
            return (<img src={SPO2_grey} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="SPO2_logo"/>)
        }
    }

    display_value(){

        let unit = ""
        if (this.props.spo2Display.spo2 !== "-"){
            unit = "%"
        }

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"5%"}}>
                {
                    this.getSpO2Img()
                }
                <Row>                    
                    <div style={{color: this.props.spo2Display.color}}>
                        <span id="row-measure-style">{this.props.spo2Display.spo2}</span>
                        <span id="row-unit-style">{unit}</span>                        
                    </div>                    
                </Row>
            </Row>
        )
    }

    //Display render
   	render(){
        return (
            <div>
                {(this.props.alert) ?
                    <Col style={{backgroundColor: "yellow"}}>
                        {this.display_value()}
                    </Col>
                    :
                    <Col>
                        {this.display_value()}
                    </Col>              
                }

            </div>
        );
   	}
}
export default (Sp02Display);